/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, { useEffect, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { approveCommentingAccessRequest, fetchCommentingRequestStatus } from '../../../../../state/thunks/commenting';
import { fetchAccountProducts } from '../../../../../state/thunks/account';
//utils
import { url } from '../../../../../utils/urls'
// material
import {SubPage, displayModal, history, log} from '@insticator/insticator-ui'; // iui-material
import NoRequest from './requeststatus/norequest';
import RequestReceived from './requeststatus/requestreceived';
import ApprovePopup from './approvepopup/approvepopup';
// styles
import injectSheet from 'react-jss';
import styles from './requestcommentwidget_styles';
// dummy data

/* ========== ~~~~~~~~~~ REQUEST COMMENT WIDGET ~~~~~~~~~~ ========== */
const RequestCommentWidget = (props) => {
  const dispatch = useDispatch()
  const { mocked, mockupGenerator, siteUUID, accountUUID, userEmail } = useSelector(state => state.session)
  const { commentingAccessRequest } = useSelector(state => state.commenting)

  useEffect(() => {
    dispatch(fetchCommentingRequestStatus(accountUUID))
  }, [])

  const requestCommentWidget = useCallback(async () => {
    log('approve commenting unit', accountUUID, userEmail)
    const response = await dispatch(approveCommentingAccessRequest({accountUUID, userEmail}))
  }, [dispatch, accountUUID])

  const approveCommenting = useCallback(async () => {
    log('approve commenting unit', accountUUID)
    const response = await dispatch(approveCommentingAccessRequest({accountUUID}))
    dispatch(displayModal(false))
    const products = await dispatch(fetchAccountProducts(accountUUID))
  }, [dispatch, accountUUID])

  const cancel = () => dispatch(displayModal(false))

  const sendRequestForWidget = () => {
      if(mocked){
          return dispatch(displayModal(true, 
            <ApprovePopup handleCancel={cancel} handleApprove={approveCommenting} />
          ));
      }
      return requestCommentWidget();
  };
    const renderCopy = () => !commentingAccessRequest.requestStatus ?
        <NoRequest 
          buttonDisabled={commentingAccessRequest.requestStatus !== null} 
          mockupGenerator={mockupGenerator} 
          requestPending={commentingAccessRequest.isApproving} 
          sendRequest={sendRequestForWidget}
        /> 
        : 
        <>{ commentingAccessRequest.requestStatus !== 'APPROVED' && <RequestReceived email={userEmail} /> }</>
   
    if(commentingAccessRequest.isFetching) return null
    
    return(
        <SubPage klass={`requestcommentwidget ${props.classes.requestcommentwidget} disabled-${commentingAccessRequest.isApproving}`} name={`requestcommentwidget`}>
            { renderCopy()}
            <div className={'graphic'}>
                <img src={`${url.image}/illustration-commenting-feature.png`} />
            </div>
        </SubPage>
    );
}



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(RequestCommentWidget);
